export const THROTTLE_NOTIFY = 4000;
export const ACTIVITY_THRESHOLD = 5000;
export const CHECK_LOOP_FREQ = 500;
